String.prototype.gllength = function(){
    let len = 0
    for(let i =0;i<this.length;i++){
        if(this.charCodeAt(i)>127||this.charCodeAt(i)==94){
            len+=2
        }
        else{
            len++
        }
    }
    return len
}
export const validategllength1to20 = (rule, value, callback) => {
    if(value != null&&value != ''){
        if (value.trim().gllength()>20) {
            callback(new Error('请输入1-20个字符'));
        }
    }
    callback()
};
export const validategllength1to60 = (rule, value, callback) => {
    if(value != null&&value != ''){
        if (value.trim().gllength()>60) {
            callback(new Error('请输入1-60个字符'));
        }
    }
    callback()
};
export const validategllength = (rule, value, callback) => {
    if(value != null&&value != ''){
        if (value.trim().gllength()>100) {
            callback(new Error('请输入1-50个汉字'));
        }
    }
    callback()
};
export const contactNamelength = (rule, value, callback) => {
    if(value != null&&value != ''){
        if (value.trim().gllength()>60) {
            callback(new Error('请输入1-60个字符'));
        }
    }
    callback()
};
export const eventAddresslength = (rule, value, callback) => {
    if(value != null&&value != ''){
        if (value.trim().gllength()>80) {
            callback(new Error('请输入1-80个字符'));
        }
    }
    callback()
};
export const eventDescriptionlength = (rule, value, callback) => {
    if(value != null&&value != ''){
        if (value.trim().gllength()>200) {
            callback(new Error('请输入1-200个字符'));
        }
    }
    callback()
};
//动态长度时规则校验
export const dynicVallength = (rule, value, callback) => {
    if(value != null&&value != ''){
        if (value.trim().gllength()> rule.maxLength) {
            callback(new Error("请输入1-"+ rule.maxLength+"个字符(1汉字=2字母=2字符)"));
        }
    }
    callback()
};
//动态长度时规则校验(最大最小长度同时)
export const dynicMaxAndMinLength = (rule, value, callback) => {
    if(value != null&&value != ''){
        if (value.trim().gllength()> rule.maxLength) {
            callback(new Error("请输入"+rule.minLength+"-"+ rule.maxLength+"个字符(1汉字=2字母=2字符)"));
        }
        if (value.trim().gllength()< rule.minLength) {
            callback(new Error("请至少输入"+ rule.minLength+"个字符(1汉字=2字母=2字符)"));
        }
    }
    callback()
};
//动态验证实数 最大值
export const dynicMaxDouble = (rule, value, callback) => {
    if(value != null&&value != ''){
        let maxInt = addEndZero(1,rule.maxLength)-1;
        let maxDou = addEndZero(1,rule.fieldDecimals)-1;
        let max = parseFloat(maxInt+'.'+maxDou);
        if (value > max) {
            callback(new Error("不能大于 "+max));
        }
    }
    callback()
};
//动态验证整数 最大值
export const dynicMaxInt = (rule, value, callback) => {
    if(value!=undefined&&value != null&&value != ''){
        let maxInt = addEndZero(1,rule.maxLength)-1
        if (value > maxInt) {
            callback(new Error("不能大于 "+maxInt));
        }
    }
    callback()
};
    /**
     * 传入num 前自动补充 0 例如  addFirstZero(32,4)   0032
     * @param num
     * @param len
     * @returns {string}
     */
 const addFirstZero = (num, len) => (`${num}`).padStart(len , '0');
/**
 * 传入num 后自动补充 0 例如  addEndZero(32,4)   320000
 * @param num
 * @param length
 * @returns {number}
 */
const addEndZero = (num, length)=>{
    let str ='0';
    for (let i = 0; i <length-1 ; i++) {
        str=str+'0'
    }
    return Number(num+str);
}
export const eventfDescriptionlength = (rule, value, callback) =>
{
    if (value != null && value != '') {
        if (value.trim().gllength() > rule.maxLength) {
            callback(new Error(`超出最大长度${rule.maxLength}个字符的限制(1汉字=2字母=2字符)`));
            ;
        }
    }
    callback()
}
;
/**
 * 动态长度时规则校验 最小长度 不能小于最小长度
 *小于最小长度 返回false  大于最小长度 返回 true
 * @param value
 * @param minLength 最小长度
 * @returns {boolean}
 */
export const dynicValMinength = (value, minLength) => {
    if (value===undefined||value.trim().gllength()< minLength) {
       return false
    }
  return true;
};
/**
 * 动态长度时规则校验 最大长度 不能大于最大长度
 *大于最大长度 返回false
 * @param value
 * @param maxLength 最大长度
 * @returns {boolean}
 */
export const dynicValMaxLength = (value, maxLength) => {
    if(value === undefined ){
        return true;
    }
    if (value.trim().gllength()> maxLength) {
        return false
    }
    return true;
};

